import { createElement } from 'react';
import { Paragraph } from '@alifd/next';
import './index.scss';
const OadpAttribute = function OadpAttribute({ id, name, code, logicalName, physicalName, attributeType, referEntity, referAttribute, defaultValue, description, required, disabled, ...otherProps }) {
    return (createElement(Paragraph, Object.assign({}, otherProps, { style: { width: '256px' } })));
};
export default OadpAttribute;
